import { type DocumentNode, gql } from '@apollo/client';

const singlePermissionGroup: DocumentNode = gql`
  query single_permissions_group($id: ID!) {
    permissionGroup(id: $id) {
      id
      name
      mediapermissionSet {
        edges {
          node {
            id
            canDownload
            canEdit
            canShare
            canDelete
            canDownload
            hires

            profile {
              id
              user {
                username
              }
            }
          }
        }
      }
      description
      mediaGroups {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;

export default singlePermissionGroup;
